module.exports = __webpack_public_path__ + "img/mittags_wertingen.f5d27a1a.jpg";